import React from 'react';
import { Button } from 'react-bootstrap5';

export default (setEditRow, setShow) => [
  {
    name: 'Bill To',
    selector: (row) => row.attributes.name,
    wrap: true,
    sortable: true,
  },
  {
    name: 'Email',
    selector: (row) => row.attributes.email,
    wrap: true,
    sortable: true,
  },
  {
    name: 'Address',
    selector: (row) => row.attributes.full_address,
    wrap: true,
    sortable: true,
  },
  {
    name: 'Payment Method',
    selector: (row) => row.attributes.payment_method,
    sortable: true,
  },
  {
    name: 'Actions',
    sortable: false,
    cell: (row) => (
      <div className="icon-with-text">
        <Button
          variant="link"
          onClick={() => {
            setEditRow(row);
            setShow(true);
          }}
        >
          <i className="small-icon edit-icon" />
        </Button>
      </div>
    ),
  },
];
